<div class="banner">
  <div class="col-12 pb-5">
    <h1>Linked Accounts</h1>
  </div>
  <div class="tab">
    <ul class="nav nav-tabs">
      <li><a [routerLink]="[{ outlets: { 'linked-accounts-tab': ['all-short-codes'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">All Short Codes</a></li>
      <li><a [routerLink]="[{ outlets: { 'linked-accounts-tab': ['needs-action'] } }]"    [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Needs Action</a></li>
      <li><a [routerLink]="[{ outlets: { 'linked-accounts-tab': ['linked-accounts'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">All Linked Accounts</a></li>
    </ul>
  </div>
</div>
<div class="tabcontent">
  <router-outlet name="linked-accounts-tab"></router-outlet>
</div>